// import { featureFlagsApiRef, useApi } from '@backstage/core-plugin-api';

export const FeatureFlags = () => {
  // const featureFlagApi = useApi(featureFlagsApiRef);
  // featureFlagApi.registerFlag({
  //   name: 'tech-radar-enabled',
  //   pluginId: 'tech-radar',
  // });
  return <></>;
};
